import { tokens } from '../tokens';

export const en = {
  [tokens.validation.email]: 'Must be a valid email',
  [tokens.validation.emailRequired]: 'Email is required',
  [tokens.validation.passwordRequired]: 'Password is required',
  [tokens.validation.mobileRequired]: 'Mobile is required',
  [tokens.validation.firstNameRequired]: 'First Name is required',
  [tokens.validation.lastNameRequired]: 'Last Name is required',
  [tokens.validation.nicknameRequired]: 'Nickname is required',
  [tokens.validation.amountRequired]: 'Amount is required',
  [tokens.validation.required]: 'This Field is required',
  //

  //
  [tokens.login.usernameLabel]: 'Username',
  [tokens.login.ForgetPasswordQuestion]: 'Forget Password?',
  [tokens.login.title]: 'Log in',
  [tokens.login.PasswordLabel]: 'Password',
  [tokens.login.submit]: 'Log in',
  //
  [tokens.changeRoleCarrier.title]: 'Change Role And Carrier',

  //
  [tokens.forgetPassword.EmailLabel]: 'Email Address',
  [tokens.forgetPassword.BackLabel]: 'Login',
  [tokens.forgetPassword.title]: 'Forgot Password',
  [tokens.forgetPassword.submit]: 'Send reset link',

  //
  [tokens.common.loading]: 'Loading',
  [tokens.common.rowPerPage]: 'Rows per page',
  [tokens.common.back]: 'Back',
  [tokens.common.cancel]: 'Cancel',
  [tokens.common.actions]: 'Actions',
  [tokens.common.cantEdit]: "cant't edit",
  [tokens.common.accept]: 'Accept',
  [tokens.common.reject]: 'Reject',
  [tokens.common.title]: 'Title',
  [tokens.common.car]: 'Car',
  [tokens.common.search]: 'Search',
  [tokens.common.filters]: 'Filters',
  [tokens.common.noFilters]: 'No filters applied',
  [tokens.common.close]: 'Close',

  //
  [tokens.nav.overview]: 'Overview',
  //
  [tokens.load.create.title]: 'Basic Information',
  [tokens.load.create.specificDeliveryTime]: 'specific Delivery Time',
  [tokens.load.create.basicInformationTitle]: 'Basic Information',
  [tokens.load.create.shipperName]: 'Shipper Name',
  [tokens.load.create.equipmentTitle]: 'Equipment',
  [tokens.load.create.submit]: 'Submit',
  [tokens.load.create.addLoadItem]: 'Add Load Item',
};
